function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import GrClose from "@meronex/icons/gr/GrClose";
import GrExpand from "@meronex/icons/gr/GrExpand";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import SideModal from "../../../Common/SideModal";
import CartSidebar from "./CartSidebar";
import { Coin } from "../DealsLayout/svg";
import { toIndianRs } from "../../../../utils/helpers";
import useBookingSummary from "../../../../Hooks/use-bookingSummary";
import { cloneElement, useEffect, useState } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function CartModal(_ref) {
  var _redux$auth;
  var openCartModal = _ref.openCartModal,
    setOpenCartModal = _ref.setOpenCartModal,
    cartValue = _ref.cartValue,
    cartCount = _ref.cartCount,
    setCartCount = _ref.setCartCount,
    setCartValue = _ref.setCartValue,
    screenBelowLg = _ref.screenBelowLg,
    redux = _ref.redux,
    winnreAuth = _ref.winnreAuth,
    appType = _ref.appType,
    isPoints = _ref.isPoints;
  var dealAction = redux === null || redux === void 0 ? void 0 : redux.dealAction;
  var history = useHistory();
  var dispatch = useDispatch();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showRewardsPopup = _useState2[0],
    setShowRewardsPopup = _useState2[1];
  var totalRewardsLength = (redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.totalRewards) || 0;
  console.log("USER REWARDS LENGTH inside cartModal", totalRewardsLength);
  var _useBookingSummary = useBookingSummary({
      redux: redux,
      winnreAuth: winnreAuth,
      appType: appType
    }, isPoints),
    userAccountSummary = _useBookingSummary.userAccountSummary,
    getUserAccountSummary = _useBookingSummary.getUserAccountSummary;
  // const screenBelowLg = useMediaQuery(theme.breakpoints.down('lg'));
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    enableExpand = _useState4[0],
    setEnableExpand = _useState4[1];
  var _useState5 = useState(-2),
    _useState6 = _slicedToArray(_useState5, 2),
    deleteIndex = _useState6[0],
    setDeleteIndex = _useState6[1];
  var isKycModalEnabled = useSelector(function (state) {
    return state.deals.isKycModalEnabled;
  });
  var isCartModalVisible = useSelector(function (state) {
    return state.deals.isCartModalVisible;
  });
  // Kyc Check
  var checkKYCStatus = function checkKYCStatus() {
    if (isPoints) {
      if (totalRewardsLength) {
        setOpenCartModal(false);
        dispatch(dealAction.setCartModalVisible(false));
        setTimeout(function () {
          dispatch(dealAction.setShowRewardsModal(true));
        }, 300);
        return;
      }
      history.push("/checkout".concat(isPoints ? "?isPoints=true" : ""));
      setOpenCartModal(false);
      dispatch(dealAction.setCartModalVisible(false));
    } else {
      winnreAuth({
        method: "GET",
        url: "/winnre/user/user/kyc-status"
      }).then(function (message) {
        if (message.message == "COMPLETED") {
          if (totalRewardsLength) {
            setOpenCartModal(false);
            dispatch(dealAction.setCartModalVisible(false));
            setTimeout(function () {
              dispatch(dealAction.setShowRewardsModal(true));
            }, 300);
            return;
          }
          history.push("/checkout".concat(isPoints ? "?isPoints=true" : ""));
          setOpenCartModal(false);
          dispatch(dealAction.setCartModalVisible(false));
        }
        if (message.message == "NOT_INITIATED" || message.message == "INITIATED" || message.message === "null" || message.message === "FAILED" || message.message == "PROCESSING") {
          dispatch(dealAction.setKycModalEnabled(true));
        }
      });
    }
  };
  var onClickHandleDeleteCart = function onClickHandleDeleteCart(index) {
    setDeleteIndex(index);
  };
  // Delete Cart value
  var onDeleteCart = function onDeleteCart(item, itemId) {
    var _window, _redux$store, _redux$store$getState, _redux$deals;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("RemoveFromCartClicked", {
      ProductName: "".concat(item === null || item === void 0 ? void 0 : item.title),
      Price: "".concat(item === null || item === void 0 ? void 0 : item.productMrp),
      PointsRequired: "".concat(item === null || item === void 0 ? void 0 : item.points)
    });
    var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
    if (!oldCartData) return;
    var cartData = JSON.parse(oldCartData);

    // Find the item to remove based on `itemId`
    var itemIndex = cartData.cartValues.findIndex(function (item) {
      return item.id === itemId;
    });
    if (itemIndex === -1) return; // Item not found, do nothing

    // Get the item to remove for updating totalMrp
    var itemToRemove = cartData.cartValues[itemIndex];

    // Remove the item from cartValues
    cartData.cartValues.splice(itemIndex, 1);

    // Update totalMrp and totalProduct
    cartData.totalMrp -= itemToRemove.productMrp;
    cartData.totalPoints -= itemToRemove.points;
    cartData.totalShippingFee -= itemToRemove.productShippingFee;
    cartData.totalConvenienceFee -= itemToRemove.productConvenienceFee;
    cartData.totalProduct -= 1;
    setCartCount(cartData.totalProduct);
    setCartValue(cartData.cartValues);
    setDeleteIndex(-2);
    if (cartData.totalProduct === 0) onCloseModal();
    // Save updated cart data to localStorage
    if (isPoints) {
      localStorage.setItem("cartData_reloyrewardpoints", JSON.stringify(cartData));
    } else {
      localStorage.setItem("cartData", JSON.stringify(cartData));
    }

    // Dispatch a custom event to notify other components
    window.dispatchEvent(new Event("cartUpdated"));
    var state = redux === null || redux === void 0 || (_redux$store = redux.store) === null || _redux$store === void 0 || (_redux$store$getState = _redux$store.getState) === null || _redux$store$getState === void 0 ? void 0 : _redux$store$getState.call(_redux$store);
    var isRefresh = state ? !state.deals.isRefreshRewards : !(redux !== null && redux !== void 0 && (_redux$deals = redux.deals) !== null && _redux$deals !== void 0 && _redux$deals.isRefreshRewards);
    // Skip the rewards re-fetch for the coin store (isPoints) flow. The points
    // list is not filtered by affordability (see getRewards in
    // DealsAndDiscounts/data.js), so re-fetching after removing an item does no
    // useful work and, because that flow appends results, it duplicates the
    // products. Other flows still refresh normally.
    if (!isPoints) {
      dispatch(dealAction.setIsRewardRefreshing(isRefresh));
    }
  };
  var handleCheckOut = function handleCheckOut() {
    getUserAccountSummary();
    checkKYCStatus();
  };
  useEffect(function () {
    if (!isCartModalVisible) {
      console.log("working Modal");
      setOpenCartModal(false);
    }
  }, [isCartModalVisible]);
  var onCloseModal = function onCloseModal() {
    var _window2;
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("AddMoreProducts");
    dispatch(dealAction.setCartModalVisible(false));
    setOpenCartModal(false);
  };
  var onClickSelectedItem = function onClickSelectedItem(id) {
    onCloseModal();
    history.push(isPoints ? "/rewardpointstore/".concat(id) : "/rewardStore/".concat(id));
  };
  console.log("cartValue", cartValue);
  // Return the modal for both small and expand screen
  var getCartDetails = function getCartDetails() {
    return /*#__PURE__*/_jsx(SideModal, {
      visible: openCartModal,
      onClick: onCloseModal,
      className: "w-full  ".concat(isKycModalEnabled ? "top-[80%]" : "", " lg:top-0 lg:w-[35%] lg:max-w-[400px] xl:w-[25%] z-[99999] !h-[50vh] lg:!h-[100vh] !bottom-[4.12rem] !lg:bottom-0"),
      children: /*#__PURE__*/_jsxs("div", {
        className: "h-full flex flex-col pl-3.5 pt-6",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex justify-between pr-3.5",
          children: [/*#__PURE__*/_jsx("h1", {
            className: "font-bold text-base  ",
            children: "Gift Basket"
          }), /*#__PURE__*/_jsx(GrClose, {
            onClick: onCloseModal,
            className: " h-4 w-4 cursor-pointer mr-2 mt-2"
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex-1 min-h-0 overflow-y-scroll overscroll-contain pr-2.5 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-400",
          children: /*#__PURE__*/_jsx("div", {
            className: "flex flex-col \n                          pt-6  space-y-4",
            children: cartValue.map(function (cart, index) {
              return /*#__PURE__*/_jsxs("div", {
                className: "relative items-start pb-2    border-b border-gray-200",
                children: [/*#__PURE__*/_jsxs("div", {
                  className: "flex flex-row gap-3 ",
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "flex flex-col   min-w-max items-start",
                    children: /*#__PURE__*/_jsx("img", {
                      src: cart !== null && cart !== void 0 && cart.thumbnailImageUrl ? cart === null || cart === void 0 ? void 0 : cart.thumbnailImageUrl : cart === null || cart === void 0 ? void 0 : cart.displayImageUrl,
                      onClick: function onClick() {
                        onClickSelectedItem(cart === null || cart === void 0 ? void 0 : cart.id);
                      },
                      alt: "Product Image",
                      className: "w-24 h-24 lg:w-20 lg:h-20 object-cover cursor-pointer"
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "flex flex-col  gap-1   justify-center flex-grow ",
                    children: [/*#__PURE__*/_jsx("p", {
                      className: "font-semibold text-sm text-black",
                      children: cart === null || cart === void 0 ? void 0 : cart.title
                    }), /*#__PURE__*/_jsx("p", {
                      className: "text-sm text-blue-700 ".concat(isPoints ? "" : "line-through"),
                      children: isPoints ? /*#__PURE__*/_jsxs("span", {
                        className: "flex items-center gap-1",
                        children: [/*#__PURE__*/cloneElement(/*#__PURE__*/_jsx(Coin, {}), {
                          className: "w-4 h-4"
                        }), /*#__PURE__*/_jsx("span", {
                          children: Number((cart === null || cart === void 0 ? void 0 : cart.points) || 0).toLocaleString("en-IN")
                        })]
                      }) : "MRP ".concat(toIndianRs(cart === null || cart === void 0 ? void 0 : cart.productMrp))
                    })]
                  }), /*#__PURE__*/_jsx("div", {
                    className: "sm:w-[10%] flex justify-center mr-1.5",
                    children: /*#__PURE__*/_jsx("button", {
                      onClick: function onClick() {
                        return onClickHandleDeleteCart(index);
                      },
                      className: "text-red-500  p-1 rounded-full transition",
                      children: /*#__PURE__*/_jsx("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "32",
                        height: "32",
                        viewBox: "0 0 26 26",
                        children: /*#__PURE__*/_jsx("g", {
                          id: "Group_12543",
                          "data-name": "Group 12543",
                          transform: "translate(-1310 -69)",
                          children: /*#__PURE__*/_jsxs("g", {
                            id: "delete-93",
                            transform: "translate(1315.333 76)",
                            children: [/*#__PURE__*/_jsx("path", {
                              id: "Path_6546",
                              "data-name": "Path 6546",
                              d: "M146.465,149.1H141.6a1.893,1.893,0,0,1-1.89-1.892v-7.564h8.643v7.564A1.894,1.894,0,0,1,146.465,149.1Zm-6.213-8.914v7.022a1.352,1.352,0,0,0,1.35,1.351h4.863a1.351,1.351,0,0,0,1.35-1.351V140.19Z",
                              transform: "translate(-136.443 -138.027)",
                              fill: "red",
                              stroke: "red",
                              "stroke-width": "0.5"
                            }), /*#__PURE__*/_jsx("path", {
                              id: "Path_6547",
                              "data-name": "Path 6547",
                              d: "M352.964,2.163h-3.78V1.082A1.082,1.082,0,0,1,350.263,0h1.621a1.081,1.081,0,0,1,1.079,1.082Zm-3.24-.542h2.7V1.082a.54.54,0,0,0-.54-.54h-1.62a.541.541,0,0,0-.54.54Z",
                              transform: "translate(-343.484)",
                              fill: "red",
                              stroke: "red",
                              "stroke-width": "0.5"
                            }), /*#__PURE__*/_jsx("path", {
                              id: "Path_6548",
                              "data-name": "Path 6548",
                              d: "M13.262,140.19H1.918a.272.272,0,0,1,0-.542H13.262a.271.271,0,0,1,0,.542ZM7.59,146.672a.272.272,0,0,1-.271-.27v-4.593a.271.271,0,0,1,.542,0V146.4A.272.272,0,0,1,7.59,146.672Zm-2.161-.54a.272.272,0,0,1-.271-.27V142.35a.271.271,0,0,1,.542,0v3.511a.27.27,0,0,1-.27.27Zm4.051,0a.27.27,0,0,1-.268-.27V142.35a.27.27,0,0,1,.539,0v3.511a.271.271,0,0,1-.271.27Z",
                              transform: "translate(0 -138.027)",
                              fill: "red",
                              stroke: "red",
                              "stroke-width": "0.5"
                            })]
                          })
                        })
                      })
                    })
                  })]
                }, index), index === deleteIndex && /*#__PURE__*/_jsxs("div", {
                  className: "flex flex-col justify-center absolute inset-0 bg-white bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50",
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "flex justify-center items-center mb-4"
                  }), /*#__PURE__*/_jsx("p", {
                    className: "text-center text-sm font-semibold text-black-600 mb-4",
                    children: "Remove item from Gift Basket?"
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "flex items-center justify-center gap-6 mb-4",
                    children: [/*#__PURE__*/_jsx("button", {
                      className: "bg-white border border-primary text-sm text-primary px-4 py-2 rounded-lg",
                      onClick: function onClick() {
                        return setDeleteIndex(-2);
                      },
                      children: "No"
                    }), /*#__PURE__*/_jsx("button", {
                      className: "bg-primary text-white text-sm px-4 py-2 rounded-lg ",
                      onClick: function onClick() {
                        return onDeleteCart(cart, cart === null || cart === void 0 ? void 0 : cart.id);
                      },
                      children: "Yes"
                    })]
                  })]
                })]
              });
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex  items-center gap-2 z-[99] lg:z-0  bg-white left-0 right-0 bottom-0 w-full fixed lg:static py-3 px-3.5 lg:pl-0 lg:pr-3.5",
          children: [/*#__PURE__*/_jsx("button", {
            onClick: onCloseModal,
            className: "flex  w-[50%]   p-[10px]  px-[5px]     items-center gap-2 border justify-center border-primary font-normal text-primary rounded-md transition   text-sm",
            children: /*#__PURE__*/_jsx("span", {
              children: "Add more products"
            })
          }), /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx("button", {
              onClick: function onClick() {
                return handleCheckOut();
              },
              className: " flex rounded-md w-[50%] p-[10px]  px-[5px]     text-center bg-primary flex items-center justify-center   text-white font-normal  text-sm ",
              children: /*#__PURE__*/_jsx("span", {
                children: " Checkout"
              })
            })
          })]
        })]
      })
    });
  };
  console.log({
    screenBelowLg: screenBelowLg,
    enableExpand: enableExpand
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [!screenBelowLg && /*#__PURE__*/_jsx("div", {
      children: enableExpand === false ? /*#__PURE__*/_jsx(CartSidebar, {
        visible: true || openCartModal,
        onClick: onCloseModal,
        className: " top-[48%] lg:top-0 ",
        children: /*#__PURE__*/_jsxs("div", {
          className: "h-full flex flex-col pt-6",
          children: [/*#__PURE__*/_jsx("div", {
            className: "absolute top-8 -left-2  w-4 h-4 bg-white border-l border-b border-gray-300 transform rotate-45"
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex items-center justify-between px-3",
            children: [/*#__PURE__*/_jsx("h1", {
              className: "font-bold text-lg",
              children: "Bag"
            }), /*#__PURE__*/_jsx(GrExpand, {
              onClick: function onClick() {
                setEnableExpand(true);
              },
              className: " h-4 w-4 cursor-pointer"
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-col  overflow-y-scroll pt-6  scrollbar-hide h-full space-y-4 px-3",
            children: cartValue.map(function (cart, index) {
              return /*#__PURE__*/_jsxs("div", {
                onClick: function onClick() {
                  setEnableExpand(true);
                },
                className: "flex flex-col items-start gap-2 cursor-pointer ",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "flex flex-row justify-between items-center w-full",
                  children: /*#__PURE__*/_jsx("img", {
                    src: cart !== null && cart !== void 0 && cart.thumbnailImageUrl ? cart === null || cart === void 0 ? void 0 : cart.thumbnailImageUrl : cart === null || cart === void 0 ? void 0 : cart.displayImageUrl,
                    alt: "Product Image",
                    className: "w-full h-full object-contain border border-gray-200"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "flex flex-col space-y-1 pt-1 flex-grow",
                  children: /*#__PURE__*/_jsx("p", {
                    className: "text-xs font-bold text-blue-700 ".concat(isPoints ? "" : "line-through"),
                    children: isPoints ? /*#__PURE__*/_jsxs("span", {
                      className: "flex items-center gap-1",
                      children: [/*#__PURE__*/cloneElement(/*#__PURE__*/_jsx(Coin, {}), {
                        className: "w-4 h-4"
                      }), /*#__PURE__*/_jsx("span", {
                        children: Number((cart === null || cart === void 0 ? void 0 : cart.points) || 0).toLocaleString("en-IN")
                      })]
                    }) : "MRP ".concat(toIndianRs(cart === null || cart === void 0 ? void 0 : cart.productMrp))
                  })
                })]
              }, index);
            })
          }), /*#__PURE__*/_jsx("div", {
            className: " w-full",
            children: /*#__PURE__*/_jsx("button", {
              onClick: handleCheckOut,
              disabled: cartCount <= 0,
              className: "py-[10px] px-6 transition text-sm w-full font-semibold ".concat(cartCount <= 0 ? "bg-gray-400 cursor-not-allowed" : "bg-primary text-white"),
              children: "Checkout"
            })
          })]
        })
      }) : getCartDetails()
    }), screenBelowLg && /*#__PURE__*/_jsx("div", {
      children: getCartDetails()
    })]
  });
}
export default CartModal;